import { useMemo } from 'react';
import * as THREE from 'three';
import { GAME_CONSTANTS } from '@/types/game';

export const WorldBoundary = () => {
  const size = GAME_CONSTANTS.WORLD_SIZE;

  // Create grid helper lines for boundaries
  const gridLines = useMemo(() => {
    const lines: THREE.Vector3[][] = [];
    const divisions = 20;
    const step = size / divisions;
    const half = size / 2;

    // Create boundary grid on each face
    // Only show subtle corner markers
    const cornerLength = size * 0.1;

    return (
      <group>
        {/* Corner markers - 8 corners of the cube */}
        {[-1, 1].map((x) =>
          [-1, 1].map((y) =>
            [-1, 1].map((z) => (
              <group key={`${x}${y}${z}`} position={[x * half, y * half, z * half]}>
                {/* X axis line */}
                <line>
                  <bufferGeometry>
                    <bufferAttribute
                      attach="attributes-position"
                      count={2}
                      array={new Float32Array([
                        0, 0, 0,
                        -x * cornerLength, 0, 0
                      ])}
                      itemSize={3}
                    />
                  </bufferGeometry>
                  <lineBasicMaterial color="#00FFFF" transparent opacity={0.3} />
                </line>
                {/* Y axis line */}
                <line>
                  <bufferGeometry>
                    <bufferAttribute
                      attach="attributes-position"
                      count={2}
                      array={new Float32Array([
                        0, 0, 0,
                        0, -y * cornerLength, 0
                      ])}
                      itemSize={3}
                    />
                  </bufferGeometry>
                  <lineBasicMaterial color="#00FFFF" transparent opacity={0.3} />
                </line>
                {/* Z axis line */}
                <line>
                  <bufferGeometry>
                    <bufferAttribute
                      attach="attributes-position"
                      count={2}
                      array={new Float32Array([
                        0, 0, 0,
                        0, 0, -z * cornerLength
                      ])}
                      itemSize={3}
                    />
                  </bufferGeometry>
                  <lineBasicMaterial color="#00FFFF" transparent opacity={0.3} />
                </line>
              </group>
            ))
          )
        )}

        {/* Subtle outer glow box */}
        <mesh>
          <boxGeometry args={[size, size, size]} />
          <meshBasicMaterial
            color="#00FFFF"
            transparent
            opacity={0.02}
            side={THREE.BackSide}
          />
        </mesh>
      </group>
    );
  }, [size]);

  return gridLines;
};
